// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"DriverShiftsPage_mainContainer__1Jj4m","gridContainer":"DriverShiftsPage_gridContainer__2yZoQ"};